import { TableCell, TableRow } from '@mui/material';
import TableHead from '@mui/material/TableHead';
import { useTranslation } from 'react-i18next';

interface Column {
  id:
    | 'no'
    | 'merchant_id'
    | 'location_id'
    | 'restaurant_id'
    | 'restaurant_name'
    | 'order_id'
    | 'order_type'
    | 'seat_number'
    | 'damaged_status'
    | 'food_id'
    | 'sku'
    | 'food_name'
    | 'quantity'
    | 'ttl_price'
    | 'selling_price'
    | 'tax_rate'
    | 'tax_amount'
    | 'before_tax_amount'
    | 'date'
    | 'completed_date'
    | 'completed_time'
    | 'delivery_date'
    | 'delivery_time'
    | 'multi_order_indicator'
    | 'rider_name'
    | 'time'
    | 'email'
    | 'phone'
    | 'gift-recipient-name'
    | 'gift-recipient-email'
    | 'gift-recipient-phone';

  label: string;
  minWidth?: number;
  format?: (value: number) => string;
  permission?: boolean;
}

const initialColumns: Column[] = [
  { id: 'no', label: 'NO', minWidth: 50 },
  { id: 'order_id', label: 'ORDER_ID', minWidth: 150 },
  { id: 'merchant_id', label: 'MERCHANT_ID', minWidth: 100, format: (value: number) => value.toLocaleString('en-US'), permission: true },
  { id: 'location_id', label: 'LOCATION_ID', minWidth: 100, format: (value: number) => value.toLocaleString('en-US'), permission: true },
  { id: 'restaurant_id', label: 'RESTAURANT_ID', minWidth: 100, format: (value: number) => value.toLocaleString('en-US'), permission: true },
  { id: 'restaurant_name', label: 'RESTAURANT_NAME', minWidth: 120, format: (value: number) => value.toLocaleString('en-US'), permission: true },
  {
    id: 'seat_number',
    label: 'SEAT_NUMBER',
    minWidth: 200,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'order_type',
    label: 'ORDER_TYPE',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'multi_order_indicator',
    label: 'MULTI_ORDER_INDICATOR',
    minWidth: 70,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'delivery_date',
    label: 'DELIVERY_DATE',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'delivery_time',
    label: 'DELIVERY_TIME',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'rider_name',
    label: 'RIDER_NAME',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'completed_date',
    label: 'COMPLETED_DATE',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'completed_time',
    label: 'COMPLETED_TIME',
    minWidth: 50,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'damaged_status',
    label: 'DAMAGED_STATUS',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'food_id',
    label: 'FOOD_ID',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'sku',
    label: 'SKU',
    minWidth: 200,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'food_name',
    label: 'FOOD_NAME',
    minWidth: 200,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'quantity',
    label: 'QUANTITY',
    minWidth: 50,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'selling_price',
    label: 'SELLING_PRICE',
    minWidth: 80,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'ttl_price',
    label: 'TTL_PRICE',
    minWidth: 80,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'tax_rate',
    label: 'TAX_RATE',
    minWidth: 80,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'tax_amount',
    label: 'TAX_AMOUNT',
    minWidth: 80,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'before_tax_amount',
    label: 'BEFORE_TAX_AMOUNT',
    minWidth: 80,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'date',
    label: 'DATE',
    minWidth: 100,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'time',
    label: 'TIME',
    minWidth: 50,
    format: (value: number) => value.toLocaleString('en-US'),
  },
  {
    id: 'email',
    label: 'EMAIL',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
    permission: true,
  },
  {
    id: 'phone',
    label: 'PHONE',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
    permission: true,
  },
  {
    id: 'gift-recipient-name',
    label: 'GIFT_RECIPIENT_NAME',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
    permission: true,
  },
  {
    id: 'gift-recipient-email',
    label: 'GIFT_RECIPIENT_EMAIL',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
    permission: true,
  },
  {
    id: 'gift-recipient-phone',
    label: 'GIFT_RECIPIENT_PHONE',
    minWidth: 150,
    format: (value: number) => value.toLocaleString('en-US'),
    permission: true,
  },
];

function TableHeadCustom({ style, showForSuperAdmin }: { style: string; showForSuperAdmin: boolean }) {
  const { t } = useTranslation();

  return (
    <TableHead className={style}>
      <TableRow>
        {initialColumns
          .filter((column) => !column.permission || showForSuperAdmin)
          .map((column) => (
            <TableCell key={column.id} style={{ minWidth: column.minWidth, borderBottom: '1px solid #e0e0e0', borderRight: '1px solid #e0e0e0', padding: '8px' }}>
              {t(`${column.label}`)}
            </TableCell>
          ))}
      </TableRow>
    </TableHead>
  );
}

export default TableHeadCustom;
